import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  FormControl,
  FormLabel,
} from '@mui/material';

const FilterDialog = ({ open, onClose, onApplyFilter }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleApply = () => {
    onApplyFilter(startDate, endDate);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Filter by Date</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <FormControl>
          <FormLabel sx={{ fontSize: '14px', color: 'black' }}>Start Date</FormLabel>
          <TextField
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel sx={{ fontSize: '14px', color: 'black' }}>End Date</FormLabel>
          <TextField
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </FormControl>

        <Button
          onClick={handleApply}
          sx={{
            color: '#000080',
            background: '#e7e7ff5c',
          }}
        >
          Get
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FilterDialog;
